import styled from 'styled-components';
import CancelledEmptySvg from '../../assets/mytrips/ic-cancelled-empty.svg';

const CancelledEmptyIcon = styled(CancelledEmptySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '12rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
`;

export default CancelledEmptyIcon;
